import styled, { FlattenSimpleInterpolation, css } from 'styled-components'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { IconProps } from 'typings/custom'
import { colors } from 'const/colors'

const getIconCss = (
  color: string,
  fontSize: string,
  marginRight: string
): FlattenSimpleInterpolation => {
  return css`
    font-size: ${fontSize};
    color: ${colors[color] || ''};
    margin-right: ${marginRight};
  `
}

export const FormatIcon = styled(({ marginRight, ...props }) => {
  return <FontAwesomeIcon {...props} />
})<IconProps>`
  ${({ color, fontSize, marginRight }) =>
    getIconCss(color, fontSize, marginRight)};
`

export const formatIconName = (value: string): Array<string> => {
  const splittedValue = value.split(/(?=[A-Z])/)
  const iconType = splittedValue[0]
  const iconName = splittedValue.slice(1).join('-').toLowerCase()
  return [iconType, iconName]
}
